module.exports = __webpack_public_path__ + "images/hitachi_smallef452939a9b2afef542898b694a6e27a.png";